import { FC } from 'react'

import { Grid } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'
import { ProcessTemplatesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { TemplateItem } from './TemplateItem'

interface Props {
  category: string
  isRoot?: boolean
}

const Templates: FC<Props> = ({ category }) => {
  const { data } = useQuery(ProcessTemplatesDocument, {
    variables: { category: category },
  })
  const templates = data?.processes.templates || []
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      transition={{ staggerChildren: 0.07, delayChildren: 0.1 }}
    >
      <Grid component="nav" variant="medium">
        {templates.map((template) => (
          <TemplateItem key={template.id} template={template} />
        ))}
      </Grid>
    </motion.div>
  )
}

export default Templates
